<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[16px] mb-[32px]">
    <div v-for="n in itemCount" :key="n" class="bg-[#fff] shadow-sm p-[12px] rounded-[16px]">
      <div class="flex gap-x-[16px] items-center">
        <div class="min-w-[64px] h-[72px] rounded-[4px] bg-gray-200 animate-pulse"></div>

        <div class="flex flex-col justify-center w-full">
          <div class="h-[20px] w-full bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingStatusCard",
  props: {
    itemCount: {
      type: Number,
      default: 4,
    },
  },
};
</script>
